require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-40-footwear-brands-to-follow-on-instagram.json") })
        }
      }, "path---blog-40-footwear-brands-to-follow-on-instagram");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-40-footwear-brands-to-follow-on-instagram!./.cache/json/blog-40-footwear-brands-to-follow-on-instagram.json
// module id = 396
// module chunks = 231608221292675